/* eslint-disable @typescript-eslint/no-var-requires */
const { version } = require("../package.json");

module.exports = version;
